import { FunctionComponent, useEffect } from "react"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { UpdateUserFormI, UpdateUserLocationStateI } from "./types"
import { SubjectRole } from "../../generated/graphql"
import { RolesUiDisplayObj } from "../../util/subjectRole"
import UpdateUserFormContainer from "./formContainer"

// TODO: this component will be cleaned up when we get... get organization membership by id
// Loading && error states to be added
const UpdateUserModal: FunctionComponent = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { userId: subjectID } = useParams()
    if (!subjectID) {
        throw new Error("No subject ID found")
    }
    const locationState = location.state as UpdateUserLocationStateI
    let initialFormState = {} as UpdateUserFormI

    if (locationState === null) {
        initialFormState = {
            firstName: "",
            lastName: "",
            userRole: SubjectRole.Unknown,
            activeUser: false,
        }
    } else {
        const role = Object.entries(RolesUiDisplayObj).find(
            ([, value]) => value === (locationState.userRole as string)
        )?.[0] as SubjectRole

        initialFormState = {
            firstName: locationState.firstName || "",
            lastName: locationState.lastName || "",
            userRole: role,
            activeUser: locationState.activeUser,
        }
    }

    useEffect(() => {
        if (locationState === null) {
            navigate("/admin/users")
        }
    }, [locationState])

    return (
        <UpdateUserFormContainer
            initialForm={initialFormState}
            email={locationState.email}
            organizationName={locationState.organizationName}
            subjectID={subjectID}
        />
    )
}

export default UpdateUserModal
